import { useEffect, useState } from 'react';
import { agentAPI } from '../services/api';

export default function TestAgentsAPI() {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('Testing API at:', process.env.REACT_APP_API_URL);
    
    agentAPI.getModels()
      .then(data => {
        console.log('Success! Response:', data);
        setResult(data);
      })
      .catch(err => {
        console.error('Error:', err);
        setError({
          message: err.message,
          status: err.response?.status,
          data: err.response?.data,
          url: err.config?.url
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 space-y-4">
      <h1 className="text-2xl font-bold">Agents API Test</h1>
      
      <div className="bg-gray-100 p-4 rounded">
        <p><strong>API URL:</strong> {process.env.REACT_APP_API_URL}</p>
        <p><strong>Endpoint:</strong> /agents/models</p>
      </div>

      {loading && <p>Loading...</p>}

      {error && (
        <div className="bg-red-100 p-4 rounded">
          <h2 className="font-bold text-red-700">Error</h2>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      )}

      {result && (
        <div className="bg-green-100 p-4 rounded">
          <h2 className="font-bold text-green-700">Success!</h2>
          <p className="mt-2"><strong>Models Count:</strong> {result.models?.length || 0}</p>
          <pre className="text-sm overflow-auto mt-2 bg-white p-2 rounded">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
